/* eslint-disable @typescript-eslint/no-explicit-any */
export const handleSelectMenuOpen = (): void => {
  setTimeout(() => {
    const menuList: any = document.querySelector(".custom-select__menu-list");
    if (menuList) {
      menuList.style.overflowY = "auto";
      menuList.style.touchAction = "pan-y";
      menuList.style.WebkitOverflowScrolling = "touch";
      
      // Remover el listener anterior si existe
      const existingListener = menuList._touchMoveHandler;
      if (existingListener) {
        menuList.removeEventListener("touchmove", existingListener);
      }
      
      const touchMoveHandler = (e: any) => e.stopPropagation();
      
      // Guardar la referencia de la función en el elemento
      menuList._touchMoveHandler = touchMoveHandler;
      
      menuList.addEventListener("touchmove", touchMoveHandler, {
        passive: true,
      });
    }

    const selectedOption: Element | undefined = document.getElementsByClassName(
      "custom-select__option--is-selected",
    )[0];

    if (selectedOption) {
      selectedOption.scrollIntoView({
        block: "center",
        inline: "end",
      });
    }
  }, 0);
};

export const defaultSelectCustomStyles = {
  input: (styles: object) => ({
    ...styles,
    height: "30px",
    flex: "0.5",
    outline: "none",
    fontSize: "0.875rem",
    fontWeight: "400",
    lineHeight: "1.25rem",
    cursor: "pointer",
    color: "rgb(var(--text-black))",
  }),
  placeholder: (styles: object) => ({
    ...styles,
    color: "rgb(var(--text-gray-500))",
    fontSize: "0.875rem",
    fontWeight: "400",
  }),
  control: (styles: object, { isDisabled }: any) => ({
    ...styles,
    backgroundColor: isDisabled
      ? "rgb(var(--bg-gray-300) / 0.2)"
      : "rgb(var(--bg-white))",
    outline: "none",
    borderColor: "rgb(var(--line-gray-200))",
  }),
  valueContainer: (styles: object) => ({
    ...styles,
    padding: "2px 10px",
  }),
  singleValue: (styles: object, { isDisabled }: any) => ({
    ...styles,
    color: isDisabled
      ? "rgb(var(--select-disabled-text))"
      : "rgb(var(--text-black))",
    fontWeight: "400",
  }),
  multiValue: (styles: object) => ({
    ...styles,
    backgroundColor: "rgb(var(--color-primary))",
    borderRadius: "4px",
  }),
  multiValueLabel: (styles: object) => ({
    ...styles,
    color: "#FFFFFF",
    fontWeight: "100",
    paddingTop: "5px",
  }),
  multiValueRemove: (styles: object) => ({
    ...styles,
    borderTopRightRadius: "4px",
    borderBottomRightRadius: "4px",
    color: "#FFFFFF",
    ":hover": {
      backgroundColor: "#F9FAFA",
      color: "#FFFFFF",
    },
  }),
  menu: (styles: object) => ({
    ...styles,
    backgroundColor: "rgb(var(--bg-white))",
    boxShadow:
      "0 0 0 1px var(--select-menu-ring), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    zIndex: 9999,
  }),
  menuList: (styles: object) => ({
    ...styles,
    backgroundColor: "transparent",
    padding: "0px 5px",
  }),
  noOptionsMessage: (styles: object) => ({
    ...styles,
    color: "rgb(var(--text-gray-500))",
  }),
  menuPortal: (styles: object) => ({
    ...styles,
    fontFamily: "Inter",
    fontSize: "0.875rem",
    fontWeight: "400",
    zIndex: 9999,
  }),
  option: (styles: object, { isSelected, isDisabled }: any) => ({
    ...styles,
    backgroundColor: isSelected
      ? "rgb(var(--bg-gray-100))"
      : "rgb(var(--bg-white))",
    color: isDisabled ? "rgb(var(--text-gray-400))" : "rgb(var(--text-black))",
    fontWeight: "400",
    padding: "6px 8px",
    borderRadius: "6px",
    margin: "5px 0px",
    cursor: isDisabled ? "not-allowed" : "pointer",
    ":hover": {
      backgroundColor:
        isDisabled && !isSelected
          ? "rgb(var(--bg-white))"
          : "rgb(var(--bg-gray-100))",
      color: isDisabled ? "rgb(var(--text-gray-400))" : "rgb(var(--text-black))",
      cursor: isDisabled ? "not-allowed" : "pointer",
    },
  }),
};
